module.exports = __webpack_public_path__ + "img/vartext4.1a3ff058.svg";